$(document).ready(function () {
  $(".forecast-vote-yes").click(function () {
    let docId = $(this).data("docid");

    $.ajax({
      method: "POST",
      url: "/ajax/forecastsetvote",
      data: { docId: docId, voteVal: 1 },
    }).done(function (resp) {
      let respObj = jQuery.parseJSON(resp);

      if (respObj.type === "success") {
        $.jGrowl(respObj.message, { theme: "tickets-message-success" });

        let percentYes = respObj.percentYes;

        let percentNo = respObj.percentNo;

        $(".forecast-percent-val-yes").text(percentYes);

        $(".forecast-percent-val-no").text(percentNo);
      } else if (respObj.type === "error") {
        $.jGrowl(respObj.message, { theme: "tickets-message-error" });
      }
    });

    return false;
  });

  $(".forecast-vote-no").click(function () {
    let docId = $(this).data("docid");

    $.ajax({
      method: "POST",
      url: "/ajax/forecastsetvote",
      data: { docId: docId, voteVal: 0 },
    }).done(function (resp) {
      let respObj = jQuery.parseJSON(resp);

      if (respObj.type === "success") {
        $.jGrowl(respObj.message, { theme: "tickets-message-success" });

        let percentYes = respObj.percentYes;

        let percentNo = respObj.percentNo;

        $(".forecast-percent-val-yes").text(percentYes);

        $(".forecast-percent-val-no").text(percentNo);
      } else if (respObj.type === "error") {
        $.jGrowl(respObj.message, { theme: "tickets-message-error" });
      }
    });

    return false;
  });
});
